var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdmoCommercialCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#EDFAF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1667 32.1084C23.42 32.2547 23.7074 32.3317 24 32.3317C24.2926 32.3317 24.58 32.2547 24.8333 32.1084L30.6667 28.7751C30.9198 28.6289 31.13 28.4188 31.2763 28.1658C31.4225 27.9127 31.4997 27.6257 31.5 27.3334V20.6667C31.4997 20.3745 31.4225 20.0874 31.2763 19.8344C31.13 19.5813 30.9198 19.3712 30.6667 19.2251L24.8333 15.8917C24.58 15.7455 24.2926 15.6685 24 15.6685C23.7074 15.6685 23.42 15.7455 23.1667 15.8917L17.3333 19.2251C17.0802 19.3712 16.87 19.5813 16.7237 19.8344C16.5775 20.0874 16.5003 20.3745 16.5 20.6667V27.3334C16.5003 27.6257 16.5775 27.9127 16.7237 28.1658C16.87 28.4188 17.0802 28.6289 17.3333 28.7751L23.1667 32.1084Z",
    stroke: "#00A651",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 32.3333V24",
    stroke: "#00A651",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7417 19.8335L24 24.0002L31.2584 19.8335",
    stroke: "#00A651",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 17.5581L27.75 21.8498",
    stroke: "#00A651",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdmoCommercialCardIcon);
export default __webpack_public_path__ + "static/media/cdmo-Commercial-card-icon.8fc1dca7eba8ba1f187837d4ac4d7e32.svg";
export { ForwardRef as ReactComponent };